import { render, staticRenderFns } from "./HistoryClubAward.vue?vue&type=template&id=2e474c6a"
import script from "./HistoryClubAward.vue?vue&type=script&lang=js"
export * from "./HistoryClubAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports